import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import { EmailTemplate } from "../../templates/interfaces/api/get-email-templates";
import { EmailFile } from "../interface/emailFile";

export const setFilesAction = createAction(
  "[Email] Set Files",
  props<{ files: EmailFile[] }>()
);

export const updateFileAction = createAction(
  "[Email] Update File",
  props<{ file: EmailFile }>()
);

export const deleteFileAction = createAction(
  "[Email] Delete File",
  props<{ id: string }>()
);

export const clearAction = createAction(
  "[Email] Clear"
);

export const setTemplateAction = createAction(
  "[Email] Set Template",
  props<{ template: EmailTemplate | null }>()
);

export const setMessageAction = createAction(
  "[Email] Set Message",
  props<{ message: string }>()
);

const actions = joinActions({
  setFilesAction,
  deleteFileAction,
  updateFileAction,
  clearAction,
  setTemplateAction,
  setMessageAction,
});

export type EmailActions = typeof actions;
